import { createReducer } from 'typesafe-actions';
import { IYandexAddressObject } from 'api/geocoder-yandex';
import { IGeometry } from 'types/omjs/project';
import { TSearchActions, searchActions } from './search-reducer-actions';

export interface IObjectSearchResult {
    layer: string;
    layer_icon: string;
    layer_name: string;
    name: string;
    name_column: string;
    orbis_id: number;
    priority: number;
    search_column: number;
    type: string;
    value: string;
}

export interface IContainerSearchResult extends omjs.IContainer {
    parentFolder?: string
}

export interface IPKKObjectSearchResult {
    name: string,
    cadastral_number: string,
    geom: IGeometry
}

export enum SearchType {
    Objects,
    Address,
    Layers,
    PKK
}

/* eslint-disable @typescript-eslint/indent */
export interface ISearchReducerState {
    search_input_value: string;
    objects_search_result:
        // Для поиска по api по объектам
        IObjectSearchResult[]
        // Для поиска по геокодеру яндекса
        | IYandexAddressObject[]
        // для поиска по слоям
        | IContainerSearchResult[]
        // для sql поиска по слоям пкк
        | IPKKObjectSearchResult[];
    search_type: SearchType;
}
/* eslint-enable @typescript-eslint/indent */

const defaultState: ISearchReducerState = {
    search_input_value: '',
    objects_search_result: [],
    search_type: SearchType.Objects
};

export const searchReducer = createReducer<ISearchReducerState, TSearchActions>(defaultState)
    .handleAction(searchActions.setSearchInputValue, (state, action) => ({
        ...state,
        search_input_value: action.payload
    }))
    .handleAction(searchActions.setOmsSearchResults, (state, action) => ({
        ...state,
        objects_search_result: action.payload
    }))
    .handleAction(searchActions.setSearchType, (state, action) => ({
        ...state,
        search_type: action.payload,
        objects_search_result: []
    }))
    .handleAction(searchActions.clearState, (state, action) => ({
        ...state,
        search_type: SearchType.Objects,
        objects_search_result: [],
        addresses_search_result: [],
        search_input_value: ''
    }));
